module.exports = __webpack_public_path__ + "static/img/lb.e33a49a9.svg";